<!-- Toolbar -->
<div class="toolbar" role="banner" *ngIf="menus && menus.length">
  <!-- Hamburger menu-->
  <div class="hamburger-menu"  appFocusOut (elementFocusOut) = "onFocusout()">
    <span class="hamburger-menu-icon" (click)="showMenu = !showMenu">
      <i class="fa fa-bars" aria-hidden="true"></i>
    </span>
    <div class="hamburger-menu-list" (click)="showMenu = !showMenu" [hidden]="!showMenu">
      <div *ngFor="let menu of menus;">
        <div class="menu">{{menu.name}}</div>
        <div *ngFor="let subMenu of menu.subMenus;">
          <div *ngIf="!subMenu.hide" class="sub-menu" [routerLink]="subMenu.url" [routerLinkActive]="['is-active']" >
              <i class="fa" [ngClass]="subMenu.iconClass" aria-hidden="true"></i>
              <span>{{subMenu.name}}</span>
              <div class="spacer"></div>
              <i class="fa fa-chevron-right" aria-hidden="true"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--need to add hanburger menu-->
  <span class="title" [routerLink]="'/dashboard'">
    <span class="header bold">{{header}}</span>
    <span class="icon">|</span>
    <span class="sub-header">{{subHeader}}</span>
    <span class="icon">|</span>
    <span class="sub-header">{{annualReporting}}</span>
  </span>
  <div class="spacer"></div>
  <!--need to add profile-->
  <app-profile></app-profile>
</div>
